import { isWalletACoinbaseSmartWallet } from '@coinbase/onchainkit/wallet';
import { useState, useEffect } from 'react';
import { useAccount, usePublicClient } from 'wagmi';

/**
 * Checks the wallet connector ID and the wallet capabilities to determine if the currently connected wallet is a
 * Coinbase Smart Wallet.
 * @returns true if the wallet is a Coinbase Smart Wallet, false otherwise.
 */
export function useIsWalletACoinbaseSmartWallet(): boolean {
  const { address } = useAccount();
  const client = usePublicClient();
  const [isSmartWallet, setIsSmartWallet] = useState(false);

  useEffect(() => {
    async function checkSmartWallet() {
      try {
        if (!address || !client) {
          setIsSmartWallet(false);
          return;
        }

        // suppress console.error from isWalletACoinbaseSmartWallet()
        const code = await client.getBytecode({ address });
        if (code === undefined) {
          setIsSmartWallet(false);
          return;
        }

        // Use type assertions to handle viem version differences
        const result = await isWalletACoinbaseSmartWallet({
          client: client as unknown,
          userOp: { sender: address } as unknown,
        });
        setIsSmartWallet(!!result);
      } catch (error) {
        // ignore all errors
        setIsSmartWallet(false);
      }
    }

    void checkSmartWallet();
  }, [address, client]);

  return isSmartWallet;
}
